module.exports = __webpack_public_path__ + "img/loby-vinedo-california.70a43c7d.jpg";